module.exports = __webpack_public_path__ + "static/media/close.552e6d6b.svg";